import { render, staticRenderFns } from "./address-tab.vue?vue&type=template&id=6f34d505&scoped=true&"
import script from "./address-tab.vue?vue&type=script&lang=js&"
export * from "./address-tab.vue?vue&type=script&lang=js&"
import style0 from "./address-tab.vue?vue&type=style&index=0&id=6f34d505&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f34d505",
  null
  
)

export default component.exports